import type { ServerPaginationConfig } from '@shared/types/module-config';

export const PROMO_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const PROMO_ROUTE_PATHS = {
  promo: '/movements/promo',
};

export const PROMO_API_PATHS = {
  rewards: '/v1/api/platform/promo/rewards',
  rewardDetail: '/v1/api/platform/promo/rewards',
  promotionUserJourney: '/v1/api/platform/promo/promotions',
  events: '/v1/api/platform/promo/events',
};

export const REWARD_TYPE_OPTIONS = [
  'WALLET_BALANCE',
  'ASTRO_COINS',
  'BONUS',
  'CHANCE',
];
